import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import i18n from '../i18n';
import { applyDocumentLocale, resolveInitialLocale } from '../utils/locale';
function getSeason() {
    const month = new Date().getMonth();
    if (month >= 2 && month <= 4)
        return 'spring';
    if (month >= 5 && month <= 7)
        return 'summer';
    if (month >= 8 && month <= 10)
        return 'autumn';
    return 'winter';
}
function getAutoTheme() {
    const hour = new Date().getHours();
    const isNight = hour < 6 || hour >= 18;
    const season = getSeason();
    return `${season}-${isNight ? 'night' : 'day'}`;
}
export const useUIStore = create()(persist((set) => ({
    sidebarOpen: true,
    currentView: 'board',
    modalOpen: null,
    theme: getAutoTheme(),
    locale: resolveInitialLocale(),
    toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
    setSidebarOpen: (open) => set({ sidebarOpen: open }),
    setCurrentView: (view) => set({ currentView: view }),
    openModal: (modalId) => set({ modalOpen: modalId }),
    closeModal: () => set({ modalOpen: null }),
    setTheme: (theme) => {
        document.documentElement.setAttribute('data-theme', theme);
        set({ theme });
    },
    setLocale: (locale) => {
        localStorage.setItem('projectmanmd-locale', locale);
        applyDocumentLocale(locale);
        i18n.changeLanguage(locale);
        set({ locale });
    },
}), { name: 'projectmanmd-ui' }));
//# sourceMappingURL=ui-store.js.map